export const SET_VEHICLE = 'SET_VEHICLE';
export const CLEAR_VEHICLE = 'CLEAR_VEHICLE';
export const INCREASE_DISTANCE_BY = 'INCREASE_DISTANCE_BY';
export const SET_DRIVING_DATA = 'SET_DRIVING_DATA';
export const SET_DEVICE_DATA = 'SET_DEVICE_DATA';
export const SET_DRIVING_VEHICLE = 'SET_DRIVING_VEHICLE';
export const REMOVE_PARKED_VEHICLE = 'REMOVE_PARKED_VEHICLE';
